import HeadImg from './head_img'

export default {
    install: function(Vue) {
        Vue.component('HeadImg', HeadImg)
    }
}